import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { AnnounceDialogComponent } from "../../modalDialogs";
import { AnounceModalResult } from "../../shared/contentTypes";
import { RemoteOrderGroupCreateConfirmService } from "./remoteOrderGroupCreateConfirm.service";
import { GroupStateService } from "../../services/groupState.service";

@Component({
  selector: "remoteOrderGroupCreateConfirm",
  templateUrl: "./remoteOrderGroupCreateConfirm.component.html",
  styleUrls: ["./remoteOrderGroupCreateConfirm.component.scss"],
  providers: [RemoteOrderGroupCreateConfirmService],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RemoteOrderGroupCreateConfirmComponent implements OnInit, OnDestroy {

  private _langSubscriber: Subscription;
  public isSmallView: boolean = false;

  public get groupName() {
    return this._remoteOrderGroupCreateConfirmService.groupName;
  }

  constructor(private _remoteOrderGroupCreateConfirmService: RemoteOrderGroupCreateConfirmService
    , private _router: Router
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _mainnavService: MainnavService
    , private _internationalisationService: InternationalisationService
    , private _coreLanguageService: CoreLanguageService
    , private _iosHelperService: IOSHelperService
    , private _groupStateService: GroupStateService
  ) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }

  ngOnInit() {
    const me = this;
    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteOrderGroupCreateConfirmComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** group created info text */
  public get groupCreatedInfo() {
    const me = this;
    return me._coreLanguageService.value("phRemoteOrder_GroupCreate_Confirm_Title")
      .replace("{groupName}", `<br><span class="emphasized">${me.groupName}</span><br>`);
  }

  /**Dialog: invite friends or put order*/
  private _openAnnounceDialog() {
    const me = this;
    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phRemoteOrder_Confirm_Invite_Dialog_Title"
        , content: "phRemoteOrder_Confirm_Invite_Dialog_SubText"
        , firstBtnLabel: "phRemoteOrder_Confirm_Invite_Dialog_OrderBtn"
        , secondBtnLabel: "phRemoteOrder_Confirm_Invite_Dialog_InviteBtn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
        me._router.navigate(["/menugroup"]);
      } else if (result === AnounceModalResult.SecondButton) {
        me.NavigateToShare();
      } else {
        // nothing
      }
    });
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /** Navigate to share link */
  public NavigateToShare() {
    const me = this;
    me._groupStateService.setshownavigatetomenu(true);
    me._router.navigate(['/remoteOrderGroupShare']);
  }

  /** navigate to menu */
  public NavigateToMenu() {
    const me = this;
    me._openAnnounceDialog();
  }
}
